export default __webpack_public_path__ + "static/windscribe-app-db2714e7fa9338abb596324cfe4ec9c1.png";